import {Thankspage} from './Thankspage';
export default Thankspage;